<script setup lang="ts">
definePageMeta({
  layout: 'auth'
})

const { login, loading, error } = useAuth()
const router = useRouter()

const form = ref({
  email: '',
  password: ''
})

const handleSubmit = async () => {
  try {
    await login(form.value.email, form.value.password)
    router.push('/dashboard')
  } catch (err) {
    console.error('登录失败:', err)
  }
}

const handleGoogleLogin = async () => {
  const supabase = useSupabaseClient()
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`
      }
    })
    
    if (error) throw error
  } catch (err) {
    console.error('Google 登录失败:', err)
  }
}
</script>

<template>
  <div class="flex flex-1 flex-col items-center justify-center">
    <div class="w-full max-w-md space-y-8 px-4">
      <div class="text-center">
        <h1 class="text-2xl font-bold tracking-tight">
          登录账户
        </h1>
        <p class="mt-2 text-sm text-muted-foreground">
          开始创建你的专业简历
        </p>
      </div>

      <form @submit.prevent="handleSubmit" class="mt-8 space-y-6">
        <div class="space-y-4">
          <div>
            <label for="email" class="block text-sm font-medium">
              邮箱地址
            </label>
            <Input
              id="email"
              v-model="form.email"
              type="email"
              required
              class="mt-1 block w-full rounded-md border border-input px-3 py-2"
              placeholder="your@email.com"
            />
          </div>

          <div>
            <label for="password" class="block text-sm font-medium">
              密码
            </label>
            <Input
              id="password"
              v-model="form.password"
              type="password"
              required
              class="mt-1 block w-full rounded-md border border-input px-3 py-2"
              placeholder="••••••••"
            />
          </div>
        </div>

        <div v-if="error" class="text-sm text-destructive">
          {{ error }}
        </div>

        <Button type="submit" class="w-full" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </Button>
        <Button 
          type="button" 
          variant="outline" 
          class="w-full" 
          :disabled="loading"
          @click="handleGoogleLogin"
        >
          <LucideGoogle class="mr-2 h-4 w-4" />
          使用 Google 账号登录
        </Button>

        <div class="text-center text-sm">
          还没有账户？
          <NuxtLink to="/auth/register" class="text-primary hover:underline">
            立即注册
          </NuxtLink>
        </div>
      </form>
    </div>
  </div>
</template>